import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-no-permission',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './no-permission.component.html',
  styleUrl: './no-permission.component.css'
})
export class NoPermissionComponent {
  constructor(private router: Router) {}

  logout(): void {
    localStorage.removeItem('jwt');
    localStorage.removeItem('jwt-password');
    localStorage.removeItem('customerId');
    this.router.navigate(['/login']);
  }
}
